import { render, staticRenderFns } from "./FormItemEdit.vue?vue&type=template&id=4b55115b"
import script from "./FormItemEdit.vue?vue&type=script&lang=js"
export * from "./FormItemEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports